import * as React from "react";
import { Stack, Card, Box } from "@mui/material";
import { DataGridPremium, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import { useGetSharedGroupAdminsQuery } from "../../../services/cclTokenedAssessmentApi";
import CclDataGridToolbar from "../../../components/common/cclDataGridToolbar/cclDataGridToolbar";
import CclCommonLink from "../../../components/common/cclCommonLink";

export interface AdministratorsCardProps {
    filteredGroupId?: number;
}

const AdministratorsCard: React.FC<AdministratorsCardProps> = (props) => {
    // const [selectedRows, setSelectedRows] = React.useState<GridSelectionModel>([]);
    const [filterModel, setFilterModel] = React.useState<any>({
        items: [],
    });

    // const [removeAdmin, { isLoading: isRemoving }] = useRemoveAdminFromGroupMutation();
    const { data: administrators = [], isLoading: isLoadingAdministrators } =
        useGetSharedGroupAdminsQuery();

    React.useEffect(() => {
        if (props.filteredGroupId !== undefined) {
            setFilterModel({
                items: [
                    {
                        columnField: "aagKey", // or the correct field for group id
                        operatorValue: "=",
                        value: String(props.filteredGroupId),
                    },
                ],
            });
        } else {
            setFilterModel({ items: [] });
        }
    }, [props.filteredGroupId]);

    const columns: GridColDef[] = [
        {
            field: "imKey",
            headerName: "ID",
            width: 100,
            type: "number",
            align: "center",
            headerAlign: "center",
            renderCell: (params) => String(params.value).replace(/,/g, ""),
        },
        {
            field: "fullName",
            headerName: "Name",
            valueGetter: (params) =>
                `${params.row.firstName ?? ""} ${params.row.lastName ?? ""}`.trim(),
            renderCell: (params: GridRenderCellParams) =>
                params.row.imKey !== "0" ? (
                    <CclCommonLink
                        text={params.value}
                        keyVal={params.value}
                        to={`/user?email=${encodeURIComponent(params.row.email)}&imkey=${
                            params.row.imKey
                        }`}
                    />
                ) : (
                    ""
                ),
            width: 200,
            flex: 0.5,
        },
        {
            field: "email",
            headerName: "Email",
            renderCell: (params: GridRenderCellParams) => (
                <CclCommonLink
                    text={params.value}
                    keyVal={params.value}
                    to={`mailto:${params.value}`}
                    type={"email"}
                />
            ),
            width: 250,
            flex: 0.65,
        },
        {
            field: "groupName",
            headerName: "Group",
            width: 250,
            flex: 1,
        },
        {
            field: "aagKey",
            filterable: true,
            headerName: "Group Key",
            width: 100,
            type: "number",
            align: "center",
            headerAlign: "center",
            renderCell: (params) => String(params.value).replace(/,/g, ""),
        },
    ];

    // const handleAddAdministrator = () => {
    //     // TODO: Open add administrator dialog
    //     setSnackbarMessage("Add administrator functionality coming soon");
    //     setSnackbarSeverity("info");
    //     setShowSnackbar(true);
    // };

    // const handleRemoveAdministrator = async () => {
    //     if (selectedRows.length === 0) {
    //         setSnackbarMessage("Please select an administrator to remove");
    //         setSnackbarSeverity("warning");
    //         setShowSnackbar(true);
    //         return;
    //     }

    //     try {
    //         for (const aagiKey of selectedRows) {
    //             const admin = administrators.find((a) => a.aagiKey === aagiKey);
    //             if (admin) {
    //                 await removeAdmin({ aagKey: admin.aagKey, imKey: admin.imKey }).unwrap();
    //             }
    //         }
    //         setSnackbarMessage(`Successfully removed ${selectedRows.length} administrator(s)`);
    //         setSnackbarSeverity("success");
    //         setShowSnackbar(true);
    //         setSelectedRows([]);
    //     } catch (err: any) {
    //         setSnackbarMessage(
    //             `Error removing administrator: ${err?.data?.message || "Unknown error"}`
    //         );
    //         setSnackbarSeverity("error");
    //         setShowSnackbar(true);
    //     }
    // };

    // const handleViewDetails = () => {
    //     if (selectedRows.length !== 1) {
    //         setSnackbarMessage("Please select one administrator to view details");
    //         setSnackbarSeverity("warning");
    //         setShowSnackbar(true);
    //         return;
    //     }
    //     // TODO: Navigate to user detail page or open detail drawer
    //     setSnackbarMessage("View details functionality coming soon");
    //     setSnackbarSeverity("info");
    //     setShowSnackbar(true);
    // };

    return (
        <Box sx={{ width: "100%", height: "100%" }}>
            <Stack spacing={2} sx={{ height: "100%" }}>
                <Card sx={{ p: 2, height: "100%", display: "flex", flexDirection: "column" }}>
                    <Box sx={{ height: "100%", width: "100%" }}>
                        <DataGridPremium
                            rows={administrators}
                            columns={columns}
                            components={{ Toolbar: CclDataGridToolbar }}
                            componentsProps={{
                                toolbar: {
                                    showSaveState: false,
                                    hideSettingsButtons: true,
                                    savestate: null,
                                    clearstate: null,
                                    miscButtons: [],
                                },
                            }}
                            initialState={{
                                sorting: { sortModel: [{ field: "fullName", sort: "asc" }] },
                            }}
                            getRowId={(row) => row.aagiKey}
                            checkboxSelection
                            filterModel={filterModel}
                            onFilterModelChange={setFilterModel}
                            loading={isLoadingAdministrators}
                            autoHeight={false}
                            sx={{ height: "100%" }}
                        />
                    </Box>
                </Card>
            </Stack>
        </Box>
    );
};

export default AdministratorsCard;
